import { apiEndpoints } from '@/lib/api/endpoints'
import { myCareApi } from '@/lib/store/api/myCareApi'
import { baseApi } from '@/lib/store/api/baseQuery'

export interface MarkQuestionnaireResponseReadResult {
    read_at: string
}

export const questionnaireResponseApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Settles a completed questionnaire's My Care row from unread (green) to
         * read (grey) the first time its detail screen is opened. Idempotent on
         * the backend, so a retry never re-dates an already-read row.
         */
        markQuestionnaireResponseRead: builder.mutation<
            MarkQuestionnaireResponseReadResult,
            { questionnaireResponseId: string }
        >({
            query: ({ questionnaireResponseId }) => ({
                url: apiEndpoints.questionnaireResponses.markRead(questionnaireResponseId),
                method: 'PATCH',
            }),
            async onQueryStarted({ questionnaireResponseId }, { dispatch, queryFulfilled }) {
                const patch = dispatch(
                    myCareApi.util.updateQueryData('getMyCare', undefined, (draft) => {
                        draft.forEach((item) => {
                            if (
                                item.kind === 'questionnaire_next_step' &&
                                item.questionnaire_response_id === questionnaireResponseId
                            ) {
                                item.unread = false
                            }
                        })
                    }),
                )
                try {
                    await queryFulfilled
                } catch {
                    patch.undo()
                }
            },
        }),
    }),
    overrideExisting: false,
})

export const { useMarkQuestionnaireResponseReadMutation } = questionnaireResponseApi
